import styled from "styled-components/macro";
import { themeVariables } from "../../../themeVariables";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 19px;
  background-color: ${themeVariables.menuColorFullscreen};
  box-shadow: ${themeVariables.dropShadow1525};
  padding: 14px;
  margin-top: 33px;

  svg {
    path {
      fill: ${themeVariables.grey0};
    }
  }

  &.collapsed {
    padding-bottom: 0px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 16px;

  .sc-title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .sc-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      h3 {
        color: ${themeVariables.grey0};
        font-family: "GT Super Text";
        font-size: 21px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .rotated-chevron {
      transform: rotate(180deg);
    }

    .chevron {
      cursor: pointer;
    }

    .hide {
      visibility: hidden;
    }
  }

  .sc-subtitle-container {
    color: ${themeVariables.grey1};
    font-family: "Inter";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-left: 3px;
  }
`;

export const BookList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  li.book-list-item {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    width: 100%;
    border-radius: 8px;
    padding: 13px 10px;
    border: 1px solid ${themeVariables.grey3};
    box-shadow: ${themeVariables.reorderablListDropShadow};
    background-color: ${themeVariables.menuColorFullscreen};
    color: ${themeVariables.grey0};
    font-family: "Inter";
    font-size: 16px;
    font-weight: 500;

    svg {
      circle {
        fill: ${themeVariables.grey0};
      }

      &:hover {
        cursor: grab;
      }
    }
  }
`;
